import { css } from '@bts-web/utils-style-engine';

export const iconWrapper = (clickable: boolean) =>
  css({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 20,
    height: 20,
    cursor: clickable ? 'pointer' : undefined,
  });
